'use strict';

const h = require('phy');

const SignInComponentWrapper = require('./sign_in_component_wrapper');
const ApplyPromoCodeContainer = require('../../containers/desktop/apply_promo_code_container');
const SelecUserComponent = require('./select_user_component');

const renderComponent = props => {
  const { isLoggedIn, isSelectUser, showCTAV1Experience } = props;

  switch (true) {
    case showCTAV1Experience && !isLoggedIn: {
      return h(SignInComponentWrapper, props);
    }
    case isSelectUser: {
      return h(SelecUserComponent, props);
    }
    default: {
      return h(ApplyPromoCodeContainer, props);
    }
  }
};

const promoWrapperComponent = props => {
  if (!props.promoMessage || props.touchRequest) return null;
  return h('.promo-code-v2', renderComponent(props));
};

module.exports = promoWrapperComponent;
